import React, { Component } from "react";

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const currentYear = new Date().getFullYear();

    // Define styles
    const styles = {
      body: {
        height: "100%",
        margin: 0,
      },
      footer: {
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#036dda",
        color: "#FFFFFF",
        textAlign: "center",
        padding: "6px 0",
        marginTop: "20px",
        zIndex: 1000,
      },
      content: {
        paddingBottom: "50px", // Adjust this value to the height of your footer
      },
    };

    return (
      <div style={styles.body}>
        <div style={styles.content}>
          {/* Your main content goes here */}
        </div>
        <div className="common-layout-footer" style={styles.footer}>
          <p>Copyright@{currentYear}. All rights reserved.</p>
        </div>
      </div>
    );
  }
}

export default Footer;
